import styled from "styled-components";

export const PostField = styled.div`
    margin-top: 30px;
    margin-left: 20px;
    margin-right: 20px;
    border-bottom: solid 1px #887ED8;
`